import React from "react";
import CircularProgress from '@material-ui/core/CircularProgress';

export default props => <span className="button-loader">
	<CircularProgress size={15} {...props} color="inherit" />
</span>
